export class LevelLayout {
	public fields = [
		{ fieldName: 'totalArea' },
		{ fieldName: 'finishedLivingArea' },
		{ fieldName: 'earthContact' },
		{ fieldName: 'levelNumber' },
		{ fieldName: 'levelLowCeiling' },
		{ fieldName: 'attic' },
		{ fieldName: 'atticAccess' },
		{ fieldName: 'cv_atticFloor' },
		{ fieldName: 'cv_atticHeated' },
		{ fieldName: 'belowGradeExits' },
		{ fieldName: 'cv_predominantWallType' },
		{ fieldName: 'cv_predominantFloorType' }
	];

	public fieldsArray = [];
}
